import { useQuery } from '@apollo/client';
import { graphql } from '@packages/charka-common-ui/graphql/types';
import { MenuSource } from '@packages/charka-common-ui/graphql/types/graphql';

const QUERY = graphql(`
  query MenuList($companyId: ID!, $menuSource: MenuSource!) {
    menus(companyId: $companyId, menuSource: $menuSource) {
      id
      title
    }
  }
`);

export function useGetMenus(companyId: string, service: MenuSource) {
  return useQuery(QUERY, {
    variables: {
      companyId,
      menuSource: service,
    },
  });
}
